// ============================================================================
//  MICHMA   SITE CONTENT
//  Edit this file to update text, links, images and stats across the site.
// ============================================================================

export const SITE = {
  name: "Michma",
  tagline: "Public Health Infinitism",
  heliosUrl: "https://www.helios.michma.org/",
  email: "info@michma.org",
  phone: "+60 17 666 4060",
  address: ["G-6,Suite Danau Kota No. 1, Jln 6a/6, Jln Tmn Ibu Kota, Taman Danau Kota, 53300 Kuala Lumpur"],
  socials: [
    { label: "Facebook", url: "https://www.facebook.com/p/Malaysian-Integrated-Community-Health-Medical-Association-Michma-100067322465921/" },
    { label: "Helios", url: "https://www.helios.michma.org/" },
  ],
};

// Navigation   order matters
export const NAV_LINKS = [
  {
    name: "About us",
    path: "/about",
    children: [
      { name: "Our Journey", path: "/about#history" },
      { name: "Logo Evolution", path: "/about#logo" },
      { name: "The Vision & Mission", path: "/about#framework" },
      { name: "The PHI Doctrine", path: "/about#phiDoctrine" },
      { name: "The Sustainable Loop", path: "/about#loop" },
      { name: "The Six Pillars", path: "/about#pillar" },
    ],
  },
  {
    name: "Our Team", 
    path: "/team",
    children: [
      { name: "Board of Council", path: "/team" },
      { name: "Executive Team", path: "/ceo" },
    ]
  },

  {
    name: "Our Activity",
    path: "/activity",
    children: [
      { name: "Healomic SoftLaunch", path: "/activity/healomic-softlaunch" },
      { name: "Mex Ride 2018", path: "/activity/mex-ride-2018" },
      { name: "Hari Denggi Asean", path: "/activity/hari-denggi-asean" },
      { name: "Anti-Smoking", path: "/activity/anti-smoking" },
    ],
  },
  { name: "Contact Us", path: "/contact" },
  { name: "Helios", path: SITE.heliosUrl, external: true, logo: "/logoHelios.png" },
];

export const IMAGES = {
  heroYouth: "/activity/head-asmoke.JPG",
  youthGroup: "/activity/head-denggi-1.JPG",
  workshop1: "/activity/head-mex2018.JPG",
  workshop2: "/activity/head-denggi-1.JPG",
};

export const STATS = [
  { value: "48K+", label: "Young people reached" },
  { value: "220+", label: "Schools & community hubs" },
  { value: "17", label: "Countries active" },
  { value: "96%", label: "Report better health confidence" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Establish Rigorous Evaluation Standards:",
    body: "Implement advanced Monitoring, Evaluation, Impact, and Reporting (MEIR) frameworks to measure and optimize health system performance globally.",
  },
  {
    n: "02",
    title: "Drive Longitudinal Research:",
    body: "Execute long-term cohort studies to track public health literacy outcomes and lifestyle interventions over extended lifespans.",
  },
  {
    n: "03",
    title: "Build Multidisciplinary Alliances:",
    body: "Connect medical professionals, researchers, educators, and policy makers to create unified public health strategies.",
  },
  {
    n: "04",
    title: "Democratize Health Knowledge:",
    body: "Deploy AI-driven platforms and open-access channels to deliver actionable public health literacy directly to communities without institutional delay.",
  },
];

export const ACTIVITIES = [
  {
    slug: "healomic-softlaunch",
    category: "Healomic SoftLaunch",
    title: "Healomic SoftLaunch",
    date: "2021",
    location: "Segamat, Johor",
    image: "/activity/head-softlaunch-1.JPG",
    images: "/activity/healomic-softlaunch.png",
    quote: "Promoting health awareness and active living within the community.",
    description: [
      "Community fun run organized in Segamat to promote health awareness and active living.",
      "Participants of all ages gathered to complete the route, fostering strong community bonds and a shared commitment to physical wellness."
    ],
    highlights: ["Healomic", "Youth Literacy", "Soft-Launching"]
  },
  // Repeat the 'images' array structure for your other activities...
  {
    slug: "mex-ride-2018",
    category: "Wellness Boot Camp",
    title: "MEX Ride 2018",
    date: "October 12, 2018",
    location: "Kuala Lumpur Expressway",
    image:"/activity/head-mex2018.JPG",
    images: "/activity/mex-ride-2018.png",
    quote: "Cycling and fitness wellness initiative promoting cardiovascular endurance.",
    description: [
      "Cycling and fitness wellness initiative promoting cardiovascular endurance and outdoor fitness.",
      "Hundreds of cycling enthusiasts participated in the route to advocate for active transportation and healthy lifestyles."
    ],
    highlights: ["Cardio Fitness", "Cycling", "Outdoor Wellness"]
  },
  {
    slug: "hari-denggi-asean",
    category: "Health Exhibition",
    title: "Hari Denggi Asean",
    date: "June 15, 2022",
    location: "Selangor",
    image:"/activity/head-denggi.JPG",
    images: "/activity/hari-denggi-asean.png",
    quote: "Educational exhibition focused on dengue prevention and vector control.",
    description: [
      "Educational exhibition focused on dengue prevention, vector control, and public health awareness.",
      "Distributed prevention kits and educated the public on eliminating Aedes mosquito breeding sites."
    ],
    highlights: ["Dengue Prevention", "Vector Control", "Public Health"]
  },
  {
    slug: "anti-smoking",
    category: "Health Exhibition",
    title: "Anti-Smoking Campaign",
    date: "November 18, 2021",
    location: "Nationwide",
    image:"/activity/head-asmoke.JPG",
    images: "/activity/anti-smoking.png",
    quote: "Highlighting the dangers of smoking and offering cessation resources.",
    description: [
      "Public awareness booth and exhibition highlighting the dangers of smoking and cessation resources.",
      "Provided counseling and support tools for individuals looking to quit smoking."
    ],
    highlights: ["Smoking Cessation", "Health Awareness", "Counseling"]
  }
];

// ============================================================================
//  ACTIVITY JOURNEY (timeline of events)
//  Each event has its OWN page at /activity/<slug>.
//  To add a new event, just push another object to this array.
//  Events are sorted automatically by year + month.
// ============================================================================
export const ACTIVITY_EVENTS = [
  {
    slug: "michma-founded-2018",
    year: 2018,
    month: 3,
    tag: "Milestone",
    title: "Michma is founded",
    summary:
      "A single after-school classroom becomes the start of a global mission for youth health literacy.",
    image: IMAGES.workshop1,
    location: "Malaysia",
    body: [
      "Michma began around a table of teens who kept asking questions their textbooks never answered. Founder Elena Márquez saw the gap and turned it into a mission.",
      "The first Michma sessions were tiny   but the moment worked. Health literacy could be taught the way young people actually talk.",
    ],
  },
  {
    slug: "first-school-partnership-2018",
    year: 2018,
    month: 9,
    tag: "Partnership",
    title: "First school partnership",
    summary:
      "Our very first classroom curriculum lands in a public high school and reaches 300+ students in one term.",
    image: IMAGES.heroYouth,
    location: "Malaysia",
    body: [
      "A local school district became the first partner to embed Michma modules into their health class.",
      "By year-end, more than 300 students had completed a full Michma unit   and their teachers were asking for more.",
    ],
  },
  {
    slug: "youth-ambassadors-launch-2019",
    year: 2019,
    month: 6,
    tag: "Program",
    title: "Youth Ambassadors program launches",
    summary:
      "A peer-led network trains its first cohort of teenage leaders to carry health literacy back into their communities.",
    image: IMAGES.youthGroup,
    location: "Global (4 countries)",
    body: [
      "We realised that the most powerful educator for a young person is often another young person. The Youth Ambassadors program was born.",
      "The first cohort trained 42 teens across four countries   many are still leading Michma chapters today.",
    ],
  },
  {
    slug: "helios-beta-2022",
    year: 2022,
    month: 4,
    tag: "Digital",
    title: "Helios platform enters beta",
    summary:
      "Our digital learning companion goes live in beta bite-sized, verified health lessons on any device.",
    image: IMAGES.workshop2,
    location: "Online",
    link: SITE.heliosUrl,
    body: [
      "Helios brought Michma into the pockets of thousands of young people. The beta launched with 60 short lessons across nutrition, mental health and body basics.",
      "Every lesson is clinician-verified and co-designed with youth for tone, length and clarity.",
    ],
  },
  {
    slug: "health-literacy-day-2026",
    year: 2026,
    month: 5,
    tag: "Event",
    title: "First global Health Literacy Day",
    summary:
      "A city-wide gathering where youth, families and clinicians learn side by side   hosted in 12 cities simultaneously.",
    image: IMAGES.heroYouth,
    location: "Malaysia Wide",
    body: [
      "Health Literacy Day turned the mission into a public celebration   workshops, storytelling, live Q&As with doctors and youth-led panels.",
      "Over 8,000 young people attended in person, and thousands more joined via Helios livestreams.",
    ],
  },
  {
    slug: "global-expansion-2026",
    year: 2026,
    month: 11,
    tag: "Milestone",
    title: "Michma active in 17 countries",
    summary:
      "Programs officially running across five continents, with a shared curriculum adapted for every context.",
    image: IMAGES.youthGroup,
    location: "5 continents",
    body: [
      "From Accra to Seoul to São Paulo, Michma chapters now deliver locally-adapted health literacy programs in 17 countries.",
      "One shared curriculum, seventeen local voices   the mission is truly global.",
    ],
  },
];


// ============================================================================
//  TEAM MEMBERS
//  Each member has their OWN detail page at /team/<slug>.
//  Edit any field below. `bio` is an array of paragraphs; `focus` is a tag list.
// ============================================================================
export const TEAM = [
  // Tier 1: Presidential Office & Secretariat
{
    name: "Hadzlinda",
    role: "President",
    slug: "dr-hadzlinda-zainal",
    image: "/team/ms-who.png",
    quote:
      "Empowering today's youth with health literacy is the greatest investment we can make for a thriving, resilient future.",
  },
  {
    name: "Nurfarahin",
    role: "Secretary",
    slug: "ms-nurfarahin",
    image: "/team/ms-who.png",
    quote:
      "Organizing pathways to knowledge ensures that every young person possesses the tools to advocate for their own future well-being.",
  },
  {
    name: "Jemima Ruran",
    role: "Assistant Secretary",
    slug: "ms-jemima-ruran",
    image: "/team/ms-ruran.png",
    quote:
      "Precision and dedication behind the scenes pave a seamless road toward a health-literate next generation.",
  },

  // Tier 2: Deputy Directors & Fiscal Control
  {
    name: "Rayhaan Dharmavilasan",
    role: "Deputy (Finance)",
    slug: "mr-rd",
    image: "/team/mr-rayhaan.jpeg",
    quote:
      "Investing in youth health literacy today yields priceless dividends for tomorrow's healthier society.",
  },
  {
    name: "Abryza Anuar",
    role: "Deputy (Education)",
    slug: "ms-abryza-anuar",
    image: "/team/ms-who.png",
    quote:
      "When we educate young minds on health, we inspire a lifetime of conscious choices and vibrant futures.",
  },
  {
    name: "Aiman",
    role: "Deputy (Health)",
    slug: "dr-a",
    image: "/team/mr-who.png",
    quote:
      "Bridging medical science with youthful curiosity creates a foundation of trust and lifelong wellness.",
  },
  {
    name: "Abry Farah",
    role: "Treasurer",
    slug: "dr-abry-farah-hanim-anuar",
    image: "/team/dr-abry.png",
    quote:
      "Sustainable resource management fuels sustainable health literacy, powering the leaders of tomorrow.",
  },
  {
    name: "Taufiq",
    role: "Assistant Treasurer",
    slug: "mr-taufiq",
    image: "/team/mr-taufiq.png",
    quote:
      "Every effort in fiscal stewardship brings us one step closer to making health education accessible to all young people.",
  },
  {
    name: "Syuhadah",
    role: "Auditor",
    slug: "ms-syuhadah",
    image: "/team/ms-syuhada.png",
    quote:
      "Upholding integrity and transparency guarantees that our promise to empower the youth stays true and impactful.",
  },

  // Tier 3: Executive & Operations
// Tier 3: Executive & Operations
{
  name: "Nazirah",
  role: "CEO",
  slug: "ms-nazirah",
  image: "/team/ms-nazirah.jpeg",
  quote:
    "Health literacy is not a privileged asset to be guarded, it is collective national wealth to be shared.",
  focus: [
    "Strategic Leadership",
    "Public Health Advocacy",
    "National Policy"
  ],
},
{
  name: "Fahada",
  role: "Director Digital",
  slug: "ms-fahada",
  image: "/team/ms-fahada.png",
  quote:
    "By pioneering modern digital ecosystem solutions, we make essential health knowledge effortlessly reachable for the youth of today.",
},
{
  name: "Anis",
  role: "Developers",
  slug: "ms-anis",
  image: "/team/ms-anis.png",
  quote:
    "Empowering youth health literacy begins with intuitive UI design making complex medical information feel modern, engaging, and easy to navigate.",
},
{
  name: "Alif",
  role: "Developers",
  slug: "mr-alif",
  image: "/team/mr-alif.png",
  quote:
    "Building robust backend systems ensures young people have uninterrupted, seamless access to reliable health guidance whenever they need it.",
},
{
  name: "Rashidi",
  role: "Developers",
  slug: "mr-rashidi",
  image: "/team/mr-rashidi.png",
  quote:
    "Optimizing code speed and web accessibility means every young user gets instant, friction-free access to life-changing health knowledge.",
},
{
  name: "Khairul",
  role: "Data Analyst",
  slug: "mr-khairul",
  image: "/team/mr-khairul.png",
  quote:
    "By analyzing youth engagement patterns, we transform data into insights that shape clearer, more impactful health literacy campaigns.",
},
{
  name: "Syamimi",
  role: "AI Engineer",
  slug: "ms-Mimi",
  image: "/team/ms-mimi.png",
  quote:
    "Harnessing intelligent AI allows us to deliver personalized, interactive health literacy experiences tailored specifically for the younger generation.",
},
{
  name: "Syakilah",
  role: "IT Multimedia",
  slug: "ms-syakilah",
  image: "/team/ms-syakila.png",
  quote:
    "Transforming complex health education into vibrant digital stories and media ensures vital health messages resonate with today's youth.",
},

  // Tier 4: Advisory Council
  {
    name: "Saravanan",
    role: "Advisor",
    slug: "dr-saravanan-s-r-sundaramurthy",
    image: "/team/dr-saravanan.png",
  },
];
export const VALUES = [
  { title: "Clarity", body: "We cut through jargon and fear. Plain language, always." },
  { title: "Trust", body: "Every fact is verified by clinicians and educators before it reaches a young person." },
  { title: "Belonging", body: "Health is personal. Our programs honour every body, culture and story." },
  { title: "Momentum", body: "We turn a single lesson into lifelong, compounding habits." },
];


// ============================================================================
//  PAGE HEADER CAROUSELS
//  Each page shows a rotating header of photos/videos. To CHANGE the media:
//   - For a PHOTO:  { type: "image", src: "https://.../photo.jpg" }
//   - For a VIDEO:  { type: "video", src: "https://.../clip.mp4" }
//  Add / remove / reorder items freely   the carousel adapts automatically.
// ============================================================================
export const PAGE_HEADERS = {
  about: {
    overline: "About us",
    titleLines: ["Public Health", "without Gatekeepers"],
    intro:
      "Malaysian Integrated Community Health Medical Association.",
    media: [
      { type: "image", src: IMAGES.youthGroup },
      { type: "image", src: IMAGES.workshop1 },
      { type: "image", src: IMAGES.heroYouth },
    ],
  },
  team: {
    overline: "Our team",
    titleLines: ["The people behind", "the mission."],
    intro:
      "Educators, clinicians, designers and young leaders united by one goal: health knowledge for all.",
    media: [
      { type: "image", src: IMAGES.team1 },
      { type: "image", src: IMAGES.team2 },
      { type: "image", src: IMAGES.youthGroup },
    ],
  },
  ceo: {
    overline: "Our CEO",
    titleLines: ["A letter from", "our founder."],
    intro:
      "Dr. Elena Márquez founded Michma on one conviction: no young person should feel lost about their own health.",
    media: [
      { type: "image", src: IMAGES.ceoPortrait },
      { type: "image", src: IMAGES.workshop2 },
    ],
  },
  activity: {
    overline: "Our activity",
    titleLines: ["Turning knowledge", "into action."],
    intro:
      "From hands-on workshops to a full digital platform, our work meets young people wherever they learn best.",
    media: [
      // Example VIDEO item   swap the src for your own .mp4 clip, or change to type "image".
      //{ type: "video", src: "/activity/head-softlaunch-1.mp4" },
      { type: "image", src: IMAGES.heroYouth },
      { type: "image", src: IMAGES.workshop1 },
      { type: "image", src: IMAGES.workshop2 },
    ],
  },
  contact: {
    overline: "Contact us",
    titleLines: ["Let's build healthier", "futures together."],
    intro:
      "Partner, volunteer, or bring Michma to your community   we'd love to hear from you.",
    media: [
      { type: "image", src: IMAGES.heroYouth },
      { type: "image", src: IMAGES.workshop1 },
    ],
  },
};
